"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = require("./Link.style");
var _CreditsMenuItem = _interopRequireDefault(require("../../../../../CreditsMenuItem"));
var _index = _interopRequireDefault(require("../../../../../Text/index"));
var _Functionality = _interopRequireDefault(require("../../../../Desktop/NavItem/Functionality"));
const NavItemLink = _ref => {
  let {
    testSectionKey,
    onClose,
    text,
    type,
    link,
    newTab,
    ...rest
  } = _ref;
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_Link.NavLink, {
      "data-test-id": "res-primary-menu-".concat(text.toLowerCase()),
      type: type,
      onClick: onClose
    }, /*#__PURE__*/_react.default.createElement(_Functionality.default, Object.assign({
      type: type,
      link: link,
      newTab: newTab
    }, rest), text === 'HeaderMenus.ToolsAndServices.Credits' ?
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(_CreditsMenuItem.default, {
      isMenuItem: true,
      isMobile: true
    }) : /*#__PURE__*/_react.default.createElement(_index.default, {
      type: "Body",
      variant: "BoldBlack",
      intlText: text
    })))
  );
};
var _default = exports.default = NavItemLink;